/* Bandeau de suggestion de langue ABN. Pas de redirection : le visiteur choisit. */
(function () {
  var tag = document.getElementById('abn-lang-suggest-js');
  if (!tag) return;

  var TEXTS = {
    fr: { msg: 'Préférez-vous consulter la boutique en français ?', go: 'Passer au français', no: 'Non merci', close: 'Fermer', label: 'Choix de la langue' },
    de: { msg: 'Möchtest du den Shop lieber auf Deutsch sehen?', go: 'Zu Deutsch wechseln', no: 'Nein danke', close: 'Schließen', label: 'Sprachauswahl' },
    es: { msg: '¿Prefieres ver la tienda en español?', go: 'Ver en español', no: 'No, gracias', close: 'Cerrar', label: 'Selección de idioma' },
    it: { msg: 'Preferisci vedere il negozio in italiano?', go: "Passa all'italiano", no: 'No, grazie', close: 'Chiudi', label: 'Scelta della lingua' },
    ja: { msg: 'ショップを日本語で見ますか？', go: '日本語に切り替える', no: 'いいえ結構です', close: '閉じる', label: '言語選択' },
    ko: { msg: '스토어를 한국어로 보시겠습니까?', go: '한국어로 전환', no: '아니요, 괜찮습니다', close: '닫기', label: '언어 선택' },
    'zh-tw': { msg: '您想以繁體中文瀏覽商店嗎？', go: '切換至繁體中文', no: '不用了，謝謝', close: '關閉', label: '語言選擇' },
    pl: { msg: 'Czy wolisz przeglądać sklep w języku polskim?', go: 'Przełącz na polski', no: 'Nie, dziękuję', close: 'Zamknij', label: 'Wybór języka' },
    sv: { msg: 'Vill du hellre se butiken på svenska?', go: 'Byt till svenska', no: 'Nej tack', close: 'Stäng', label: 'Val av språk' },
    nb: { msg: 'Vil du heller se butikken på norsk?', go: 'Bytt til norsk', no: 'Nei takk', close: 'Lukk', label: 'Språkvalg' },
    lt: { msg: 'Ar norėtumėte peržiūrėti parduotuvę lietuviškai?', go: 'Perjungti į lietuvių kalbą', no: 'Ne, ačiū', close: 'Uždaryti', label: 'Kalbos pasirinkimas' }
  };
  var KEY = 'abn_lang_suggest_off';
  var DAYS = 90;

  var current = (tag.getAttribute('data-current') || '').toLowerCase();
  var roots = {};
  (tag.getAttribute('data-langs') || '').split(',').forEach(function (pair) {
    var p = pair.split('|');
    if (p[0] && p[1]) roots[p[0].toLowerCase()] = p[1];
  });

  function dismissed() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (v && Date.now() - parseInt(v, 10) < DAYS * 864e5) return true;
    } catch (e) {}
    return document.cookie.split('; ').some(function (c) { return c.indexOf(KEY + '=') === 0; });
  }

  function remember() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    document.cookie = KEY + '=1; path=/; max-age=' + DAYS * 86400 + '; SameSite=Lax';
  }

  function pickLanguage() {
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    for (var i = 0; i < list.length; i++) {
      var raw = String(list[i]).toLowerCase();
      if (!raw) continue;
      var primary = raw.split('-')[0];
      // Teste d'abord le tag complet (ex: zh-tw), sinon la sous-etiquette principale (ex: fr).
      var code = roots[raw] ? raw : (roots[primary] ? primary : null);
      if (!code) continue;
      // La premiere langue du navigateur que la boutique publie decide. Si c'est la langue affichee, on se tait.
      return code === current ? null : (TEXTS[code] ? code : null);
    }
    return null;
  }

  function targetUrl(code) {
    var path = window.location.pathname;
    var curRoot = roots[current] || '/';
    if (curRoot !== '/' && (path === curRoot || path.indexOf(curRoot + '/') === 0)) {
      path = path.slice(curRoot.length) || '/';
    }
    var root = roots[code];
    var full = root === '/' ? path : (path === '/' ? root : root + path);
    return full + window.location.search + window.location.hash;
  }

  function build(code) {
    var t = TEXTS[code];
    var names = {fr:'Français',de:'Deutsch',es:'Español',it:'Italiano',ja:'日本語',ko:'한국어','zh-tw':'繁體中文',pl:'Polski',sv:'Svenska',nb:'Norsk',lt:'Lietuvių'};
    var announcement = document.querySelector('.announcement-content');
    var slot = announcement && announcement.closest('.shopify-section');
    if (!slot || slot.getBoundingClientRect().height < 44) return;
    var css = document.createElement('style');
    css.textContent =
      '#abn-lang-suggest{position:relative;z-index:31;background:#fff;color:#3a1f2b;' +
      'border-bottom:2px solid #85284a;box-shadow:0 4px 18px rgba(0,0,0,.12);font-size:15px;line-height:1.4;' +
      'width:100%;box-sizing:border-box}' +
      '#abn-lang-suggest.is-open{transform:none}' +
      '#abn-lang-suggest.in-announcement{position:absolute;inset:0;height:100%;min-height:48px}' +
      '#abn-lang-suggest .abn-ls-in{max-width:1100px;height:100%;box-sizing:border-box;margin:0 auto;padding:1px 48px 1px 16px;display:flex;flex-wrap:nowrap;align-items:center;gap:8px 14px}' +
      '#abn-lang-suggest p{margin:0;flex:1 1 220px}' +
      '#abn-lang-suggest a,#abn-lang-suggest button{font:inherit;cursor:pointer;border-radius:4px;min-height:44px}' +
      '#abn-lang-suggest .abn-ls-go{background:#85284a;color:#fff;text-decoration:none;padding:9px 16px;display:inline-flex;align-items:center}' +
      '#abn-lang-suggest .abn-ls-no{background:none;border:1px solid #85284a;color:#85284a;padding:8px 14px}' +
      '#abn-lang-suggest .abn-ls-short{display:none}' +
      '#abn-lang-suggest .abn-ls-x{position:absolute;top:1px;right:2px;width:44px;height:44px;background:none;border:0;color:#3a1f2b;font-size:24px;line-height:1}' +
      '#abn-lang-suggest a:focus-visible,#abn-lang-suggest button:focus-visible{outline:3px solid #1a73e8;outline-offset:2px}' +
      '@media (max-width:989px){#abn-lang-suggest{font-size:14px}#abn-lang-suggest .abn-ls-in{padding:1px 48px 1px 12px;gap:6px 10px}#abn-lang-suggest p,#abn-lang-suggest .abn-ls-full{display:none}#abn-lang-suggest .abn-ls-short{display:inline}}' +
      '@media (prefers-reduced-motion:reduce){#abn-lang-suggest{transition:none}}';
    document.head.appendChild(css);

    var box = document.createElement('div');
    box.id = 'abn-lang-suggest';
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', t.label);
    box.setAttribute('lang', code);
    box.innerHTML =
      '<div class="abn-ls-in"><p></p>' +
      '<a class="abn-ls-go" hreflang="' + code + '"></a>' +
      '<button type="button" class="abn-ls-no"></button>' +
      '<button type="button" class="abn-ls-x"><span aria-hidden="true">&times;</span></button></div>';
    box.querySelector('p').textContent = t.msg;
    var go = box.querySelector('.abn-ls-go');
    var fullLabel = document.createElement('span');
    fullLabel.className = 'abn-ls-full';
    fullLabel.textContent = t.go;
    var shortLabel = document.createElement('span');
    shortLabel.className = 'abn-ls-short';
    shortLabel.textContent = names[code] || t.go;
    go.appendChild(fullLabel);
    go.appendChild(shortLabel);
    go.setAttribute('aria-label', t.go);
    go.href = targetUrl(code);
    box.querySelector('.abn-ls-no').textContent = t.no;
    box.querySelector('.abn-ls-x').setAttribute('aria-label', t.close);

    function close() {
      remember();
      document.removeEventListener('keydown', onKey);
      if (box.contains(document.activeElement)) {
        var language = document.querySelector('[id^="HeaderLanguageForm"] button, .header__heading-link');
        if (language) language.focus({ preventScroll: true });
      }
      if (box.parentNode) box.parentNode.removeChild(box);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.querySelector('.abn-ls-no').addEventListener('click', close);
    box.querySelector('.abn-ls-x').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    if (getComputedStyle(slot).position === 'static') slot.style.position = 'relative';
    box.classList.add('in-announcement');
    slot.appendChild(box);
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-open'); }); });
  }

  // Une seule apparition par session : ignore une fois, le bandeau ne suit plus le visiteur de page en page.
  var SEEN = 'abn_lang_suggest_seen';
  function seenThisSession() {
    try { return window.sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; }
  }

  // Le bandeau cookies passe d'abord : deux bandeaux a la fois, le visiteur ferme les deux sans lire.
  function consentPending() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || !cp.shouldShowBanner || !cp.shouldShowBanner()) return false;
    var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : null;
    if (!c) return false;
    for (var k in c) { if (c[k] !== '') return false; }
    return true;
  }

  function show() {
    if (dismissed() || seenThisSession()) return;
    var code = pickLanguage();
    if (!code) return;
    try { window.sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    build(code);
  }

  function init() {
    if (dismissed() || seenThisSession() || !pickLanguage()) return;
    var tries = 0;
    (function wait() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp && tries++ < 15) return setTimeout(wait, 200);
      if (!consentPending()) return show();
      document.addEventListener('visitorConsentCollected', function () { setTimeout(show, 500); }, { once: true });
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
